// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2_GMJ","topBottomGutter":"Layout_topBottomGutter__1Wt0u"};